module.exports = __webpack_public_path__ + "img/svg_bg.6b66c548.svg";